import { handleApi } from '../../common';
import { COMMON } from '../../../strings/common';
import axios from 'axios';

const API_ENDPOINTS = {
	getWithdrawFundsSummery: '/api/equity/api/eqm/payout/request/summary',
	createWithdrawRequest: '/api/equity/api/eqm/payout/request/create',
	updateWithdrawRequest: '/api/equity/api/eqm/payout/request/update',
	cancelWithdrawRequest: '/api/equity/api/eqm/payout/request/cancel',
};

export const fetch_withdraw_summery_data = async (Api, token = '') => {
	const response = await Api.get(
		API_ENDPOINTS.getWithdrawFundsSummery,
		{},
		{},
		token,
	);
	if (axios.isCancel(response)) {
		throw COMMON.ApiCancelled;
	}
	const result = handleApi(response);

	return result;
};

export const create_withdraw_fund_request = async (
	Api,
	payload = {},
	token = '',
) => {
	const response = await Api.post(
		API_ENDPOINTS.createWithdrawRequest,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const update_withdraw_fund_request = async (
	Api,
	payload = {},
	token = '',
) => {
	const response = await Api.post(
		API_ENDPOINTS.updateWithdrawRequest,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};

export const cancel_withdraw_fund_request = async (
	Api,
	payload = {},
	token = '',
) => {
	const response = await Api.post(
		API_ENDPOINTS.cancelWithdrawRequest,
		payload,
		{},
		token,
	);
	const result = handleApi(response);
	return result;
};
